// Translation Loader export function
import { LOCATION_INITIALIZED } from '@angular/common'
import { Injector } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

// This is required in order to preload (use()) the translations. Without this, refreshing proficloud (F5) would lead to
// untranslated strings
export function TranslationFactory(translate: TranslateService, route: ActivatedRoute, injector: Injector) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null))
      locationInitialized.then(() => {
        // Define possible languages here
        const en = 'en-GB'
        const de = 'de-DE'
        translate.addLangs([en, de])

        // Define english as default language
        translate.setFallbackLang(en)

        // Check for a locale property
        route.queryParamMap.subscribe((params) => {
          const locale = params?.get('locale') ?? en

          // Preloading the German language is currently necessary since ngrx has problems with dynamically switching to not preloaded languages for some reason
          translate.use(de).subscribe({
            next: () => {
              console.debug(`Successfully preloaded '${de}' language.`)
              // Switch back to the default language (en-GB)
              // THIS IS THE ONLY PLACE IF YOU WANT TO CHANGE THE DEFAULT LOCALE ON APP LOAD!!!
              translate.use(locale).subscribe({
                next: () => {
                  console.debug(`Switched to locale '${locale}' language.`)
                  resolve(null)
                },
                error: (err) => {
                  console.error(`Error switching back to '${en}':`, err)
                  resolve(null)
                },
              })
            },
            error: (err) => {
              console.error(`Error preloading '${de}':`, err)
              resolve(null)
            },
          })
        })
      })
    })
}
